import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface Category {
  title: string;
  image: string;
  href: string;
}

@Component({
  selector: 'app-categories-slider',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './categories-slider.component.html',
  styleUrl: './categories-slider.component.scss',
})
export class CategoriesSliderComponent {
  categories: Category[] = [
    {
      title: 'Non-Profits',
      image: 'assets/images/nonprofit-small.png',
      href: '#'
    },
    {
      title: 'Concerned Citizens',
      image: 'assets/images/citizen-small.jpg',
      href: '#'
    },
    {
      title: 'Political Candidates',
      image: 'assets/images/candidate-small.jpg',
      href: '#'
    }
  ];
}
